// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td {
  width: 200px;
  font-family: GothamRounded-Book;
  text-align: justify;
  vertical-align: baseline;
  padding: 10px;
}

p {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/stopRoutePlate/stopRoutePlateRow.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["td {\n  width: 200px;\n  font-family: GothamRounded-Book;\n  text-align: justify;\n  vertical-align: baseline;\n  padding: 10px;\n}\n\np {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
